import { render } from "./AttachVolume.vue?vue&type=template&id=50c6c444&scoped=true"
import script from "./AttachVolume.vue?vue&type=script&lang=js"
export * from "./AttachVolume.vue?vue&type=script&lang=js"

import "./AttachVolume.vue?vue&type=style&index=0&id=50c6c444&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.21.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c6c444"]])

export default __exports__